<script>
export default {
  name: 'GaBaseFoldedFilter',
  props: {
    title: {
      type: String,
      required: true,
    },
    nbSelected: {
      type: Number,
      required: false,
      default: 0,
    },
    subtitle: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
  },
  emits: ['expand'],
  computed: {
    hasIcon() {
      return this.icon !== null;
    },
  },
};
</script>

<template>
  <div class="w-full group px-8 cursor-pointer" @click="$emit('expand')">
    <div class="border-b border-grey-100 group-last:border-b-0 py-6 flex justify-between items-center gap-2 max-w-full">
      <div class="flex flex-col gap-2 grow min-w-0">
        <div class="flex items-center gap-2">
          <div v-if="hasIcon" class="rounded-md h-[32px] w-[32px] bg-secondary-50 flex items-center justify-center">
            <i class="ga-icon text-grey-900 text-2xl" :class="icon" />
          </div>
          <span class="text-md text-grey-900 font-medium select-none"> {{ title }} </span>
          <div
            v-if="nbSelected"
            class="rounded-full font-medium text-sm text-[#ECF7FE] bg-primary flex items-center justify-center w-[20px] h-[20px] select-none">
            {{ nbSelected }}
          </div>
        </div>
        <span class="text-grey-500 w-full text-ellipsis text-nowrap overflow-hidden select-none">
          {{ subtitle }}
        </span>
      </div>
      <i class="ga-icon ga-chevron_right text-grey-900 text-md" />
    </div>
  </div>
</template>

<style scoped></style>
